/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { ActionEditorModule } from "./ActionEditor/ActionEditorModule";
import { DemoModule } from "./Demo/DemoModule";
import { OverviewModule } from "./Overview/OverviewModule";
import { TestModule } from "./TestModule/TestModule";
import { ViewEditorModule } from "./ViewEditor/ViewEditorModule";
import { IntegrationEditorModule } from "./IntegrationEditor/IntegrationEditorModule";
import { DebugToolsModule } from "./DebugTools/DebugToolsModule";
import { WelcomeModule } from "./Welcome/WelcomeModule";
import { AssetModule } from "./Asset/AssetModule";
import { ConfigEditorModule } from "./ConfigEditor/ConfigEditorModule";
import { EndpointEditorModule } from "./EndpointEditor/EndpointEditorModule";
import { ThemeEditorModule } from "./ThemeEditor/ThemeEditorModule";
import { ReadmeEditorModule } from "./ReadmeEditor/ReadmeEditorModule";

export const coreModules = {
	actionEditor: ActionEditorModule,
	asset: AssetModule,
	configEditor: ConfigEditorModule,
	debugTools: DebugToolsModule,
	demo: DemoModule,
	endpointEditor: EndpointEditorModule,
	integrationEditor: IntegrationEditorModule,
	overview: OverviewModule,
	readmeEditor: ReadmeEditorModule,
	test: TestModule,
	themeEditor: ThemeEditorModule,
	viewEditor: ViewEditorModule,
	welcome: WelcomeModule
};
